

import Countries from "@/entities/Countries/CountriesFormMap";
import Games from "@/entities/Games/GameFormMap";
import GeneralSettings from "@/entities/GeneralSettings/GeneralSettingsFormMap";
import HomeHighlightsV2 from "@/entities/HomeHighlightsV2/HomeHighlightsV2FormMap";
import PlayersOfPeriod from "@/entities/PlayersOfPeriod/PlayersOfPeriodFormMap";
import Notifications from "@/entities/Notifications/NotificationsFormMap";
import Leagues from "@/entities/Leagues/LeaguesFormMap";
import Markets from "@/entities/Markets/MarketsFormMap";
import TextConstant from "@/entities/TextConstant/TextConstantFormMap";
import Teams from "@/entities/Teams/TeamsFormMap";
import Missions from "@/entities/Missions/MissionsFormMap";
import Transactions from "@/entities/Transactions/TransactionsFormMap";
import Faq from "@/entities/Faq/FaqFormMap";
import RewardSettings from "@/entities/RewardSettings/RewardSettingsFormMap";
import BettingCompanies from "@/entities/BettingCompanies/BettingCompaniesFormMap";
import Coupons from "@/entities/Coupons/CouponsFormMap";
import Tournaments from "@/entities/Tournaments/TournamentsFormMap";
import Sponsors from "@/entities/Sponsors/SponsorsFormMap";
import UsersForm from "@/entities/Users/UserFormMap";
import { Names,Paths } from '@/core/config/enums/SitePaths';
import { Endpoints } from '@/api/ApiEndpoints';
const GeneralFormMapping = 
  [
    
    
      
      {
          
        map:  Games,
        endpoint: Endpoints.GAMES,
        singleEndpoint: Endpoints.SINGLE_GAME,
        updateEndpoint: Endpoints.UPDATE_GAME,
        key: Names.GAMES,
        updatePath: Paths.GAMES_EDIT,
      },      
      {

        map:  GeneralSettings,
        endpoint: Endpoints.GENERAL_SETTINGS,
        singleEndpoint: Endpoints.SINGLE_GENERAL_SETTINGS,
        updateEndpoint: Endpoints.SINGLE_GENERAL_SETTINGS,
        key: Names.GENERAL_SETTINGS_EDIT,
        updatePath: Paths.GENERAL_SETTINGS_EDIT,
      },
      {
        map: PlayersOfPeriod,
        endpoint: Endpoints.PLAYERS_OF_PERIOD,
        singleEndpoint: Endpoints.PLAYERS_OF_PERIOD,
        updateEndpoint: Endpoints.PLAYERS_OF_PERIOD_UPDATE,
        key: Names.PLAYERS_OF_PERIOD_EDIT,
        updatePath: Paths.PLAYERS_OF_PERIOD_EDIT,
      },
      {
        map: HomeHighlightsV2,
        endpoint: Endpoints.HOME_HIGHLIGHTS_V2,
        singleEndpoint: Endpoints.HOME_HIGHLIGHTS_V2,
        updateEndpoint: Endpoints.HOME_HIGHLIGHTS_V2_UPDATE,
        key: Names.HOME_HIGHLIGHTS_V2_EDIT,
        updatePath: Paths.HOME_HIGHLIGHTS_V2_EDIT,
      },      
      {
          
        map:  RewardSettings,
        endpoint: Endpoints.REWARD_SETTINGS,
        singleEndpoint: Endpoints.REWARD_SETTINGS,
        updateEndpoint: Endpoints.REWARD_SETTINGS,
        key: Names.REWARD_SETTINGS_EDIT,
        updatePath: Paths.REWARD_SETTINGS_EDIT,
      },      
      {
          
        map:  BettingCompanies,
        endpoint: Endpoints.BETTING_COMPANIES,
        singleEndpoint: Endpoints.BETTING_COMPANIES,
        addEndpoint: Endpoints.BETTING_COMPANIES,
        updateEndpoint: Endpoints.BETTING_COMPANIES,
        key: Names.BETTING_COMPANIES,
        addPath: Paths.BETTING_COMPANIES_ADD,
        updatePath: Paths.BETTING_COMPANIES_EDIT,
      },      
      {
          
        map:  Notifications,
        endpoint: Endpoints.PUSH_NOTIFICATIONS,
        addEndpoint: Endpoints.PUSH_NOTIFICATIONS_ADD,
        key: Names.NOTIFICATIONS_ADD,
        updatePath: Paths.NOTIFICATIONS_ADD,
      },   
      {
          
        map:  Missions,
        endpoint: Endpoints.MISSIONS,
        addEndpoint: Endpoints.ADD_MISSION,
        updateEndpoint: Endpoints.UPDATE_MISSION,
        key: Names.MISSIONS,
        addPath: Paths.MISSIONS_ADD,
        updatePath: Paths.MISSIONS_EDIT,
      },      
      {
          
        map:  Transactions,
        endpoint: Endpoints.TRANSACTIONS,
        addEndpoint: Endpoints.ADD_TRANSACTION,
        updateEndpoint: Endpoints.UPDATE_TRANSACTION,
        key: Names.TRANSACTIONS,
        addPath: Paths.TRANSACTIONS_ADD,
        updatePath: Paths.TRANSACTIONS_EDIT,
      },      
        
     
      {
        
        map:  Countries,
        endpoint: Endpoints.COUNTRIES,
        addEndpoint: Endpoints.ADD_COUNTRIES,
        updateEndpoint: Endpoints.UPDATE_COUNTRIES,
        deleteEndpoint: Endpoints.DELETE_COUNTRIES,
        key: Names.COUNTRIES,
        addPath: Paths.COUNTRIES_ADD,
        updatePath: Paths.COUNTRIES_EDIT,
      },
      {
        
        map:  Faq,
        endpoint: Endpoints.ADMIN_FAQ,
        singleEndpoint: Endpoints.ADMIN_FAQ,
        addEndpoint: Endpoints.ADMIN_FAQ,
        updateEndpoint: Endpoints.UPDATE_ADMIN_FAQ,
        deleteEndpoint: Endpoints.ADMIN_FAQ,
        key: Names.FAQ,
        addPath: Paths.FAQ_ADD,
        updatePath: Paths.FAQ_EDIT,
      },
      {
        
        map:  Leagues,
        endpoint: Endpoints.LEAGUES,
       
        updateEndpoint: Endpoints.UPDATE_LEAGUES,
        deleteEndpoint: Endpoints.DELETE_LEAGUES,
        key: Names.LEAGUES,
        addPath: Paths.LEAGUES_ADD,
        updatePath: Paths.LEAGUES_EDIT,
      },
       {
        
        map:  Markets,
        endpoint: Endpoints.MARKETS,
        addEndpoint: Endpoints.ADD_MARKETS,
        updateEndpoint: Endpoints.UPDATE_MARKETS,
        deleteEndpoint: Endpoints.MARKETS,
        key: Names.MARKETS,
        addPath: Paths.MARKETS_ADD,
        updatePath: Paths.MARKETS_EDIT,
      },
      {
        
        map:  TextConstant,
        endpoint: Endpoints.TEXT_CONSTANTS,
        addEndpoint: Endpoints.ADD_TEXT_CONSTANTS,
        updateEndpoint: Endpoints.UPDATE_TEXT_CONSTANTS,
        deleteEndpoint: Endpoints.TEXT_CONSTANTS,
        key: Names.TEXT_CONSTANTS,
        addPath: Paths.TEXT_CONSTANTS_ADD,
        updatePath: Paths.TEXT_CONSTANTS_EDIT,
      },
      {

        map:  Coupons,
        endpoint: Endpoints.COUPONS,
        singleEndpoint: Endpoints.COUPONS,
        updateEndpoint: Endpoints.COUPON_UPDATE_STATUS,
        key: Names.COUPONS_EDIT,
        updatePath: Paths.COUPONS_EDIT,
      },
      {
        
        map:  Teams,
        endpoint: Endpoints.TEAMS,
        addEndpoint: Endpoints.ADD_TEAMS,
        updateEndpoint: Endpoints.UPDATE_TEAMS,
        deleteEndpoint: Endpoints.DELETE_TEAMS,
        key: Names.TEAMS,
        addPath: Paths.TEAMS_ADD,
        updatePath: Paths.TEAMS_EDIT,
      },
      {

        map:  Tournaments,
        endpoint: Endpoints.ADMIN_TOURNAMENT,
        addEndpoint: Endpoints.ADMIN_TOURNAMENT,
        updateEndpoint: Endpoints.ADMIN_TOURNAMENT,
        key: Names.TOURNAMENTS,
        addPath: Paths.TOURNAMENTS_ADD,
        updatePath: Paths.TOURNAMENTS_EDIT,
      },
      {
        map: Sponsors,
        endpoint: Endpoints.ADMIN_SPONSOR,
        addEndpoint: Endpoints.ADMIN_SPONSOR,
        updateEndpoint: Endpoints.ADMIN_SPONSOR,
        key: Names.SPONSORS,
        addPath: Paths.SPONSORS_ADD,
        updatePath: Paths.SPONSORS_EDIT,
      },
      {
        map: UsersForm,
        endpoint: Endpoints.USERS,
        singleEndpoint: Endpoints.USERS,
        updateEndpoint: Endpoints.UPDATE_USERS_NICKNAME,
        key: Names.USERS,
      },
      
     
  ];
  const getFormMapping =  ((key) => {
    
    const filteredMaps = GeneralFormMapping.filter(function(ele){
       
        return key == ele.key
    });
    if(filteredMaps.length>0){
        return filteredMaps[0];
    }
    return;
  });
  const getFormMappingKey =  ((key) => {
    const filteredMaps = GeneralFormMapping.filter(function(ele){
       
        return key == ele.key
    });
    if(filteredMaps.length>0){
        return filteredMaps[0].key;
    }
    return;
  });

export  {
    getFormMapping,
    getFormMappingKey
};
